/**
 * returns the validity for the configurator and the prescription info section
 */ const validateConfigurator = (config, isPrescriptionInfoEnabled)=>{
    var ref;
    const leftEyeValid = config.leftEyeChecked ? !!config.leftEyeBoxSKU : true;
    const rightEyeValid = config.rightEyeChecked ? !!config.rightEyeBoxSKU : true;
    const isConfiguratorValid = leftEyeValid && rightEyeValid;
    const isPrescriptionInfoValid = isPrescriptionInfoEnabled ? (config === null || config === void 0 ? void 0 : (ref = config.prescriptionInfo) === null || ref === void 0 ? void 0 : ref.valid) || false : true;
    return {
        isConfiguratorValid,
        isPrescriptionInfoValid
    };
};

export { validateConfigurator };
//# sourceMappingURL=validate-configurator.js.map
